<template>
  <v-container fluid pl-4>
    <v-layout row wrap pl-2 pr-4>
      <v-flex xs12>
        <v-form row wrap ref="form">
          <v-layout row wrap>
            <v-flex xs12>
              <textarea
                :ref="autoCompleteRef"
                v-model="text"
                v-validate="'required|max:10000'"
                data-vv-name="text"
                data-vv-as="texto"
                placeholder="Texto"
                @keydown.enter="avoidEmptyLines($event)"
                :class="{awesomplete: true, 'has-error': errors.has('text')}"
                data-multiple
                spellcheck="false">
              </textarea>
              <small class="p-absolute" id="text-error" v-if="errors.has('text')">
                {{ errors.first('text') }}
              </small>
            </v-flex>
          </v-layout>
          <v-layout row wrap id="fallback-action-buttons">
            <v-flex md3 offset-md6 text-xs-right>
              <v-btn flat @click="close()">Cancelar</v-btn>
            </v-flex>
            <v-flex md3 text-xs-right>
              <v-btn flat class="k-orange-linear-text" @click="save()" :disabled="errors.any()">Guardar</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import EventBus from '@/event-bus';
import sidebarFormMixin from '@/mixins/sidebarForm';
import autoCompleteMixin from '@/mixins/autoComplete';

export default {
  mixins: [
    sidebarFormMixin,
    autoCompleteMixin,
  ],
  data() {
    return {
      form: {
        text: '',
      },
      text: '',
      autoCompleteRef: 'awesompleteFallback',
      backdropRef: 'backdropFallback',
      highlightsRef: 'highlightsFallback',
      autocompleteList: [
        'nombre_completo',
        'nombre',
        'apellido',
        'monto',
        'fecha_vencimiento',
        'moneda',
        'mañana',
      ],
      sideBarFormBus: {
        sidebarFormError: 'sidebarFormErrorBotWorkflow',
        openRightDrawer: 'openRightDrawerBotWorkflow',
        rightDrawerSaved: 'rightDrawerSavedBotWorkflow',
        closeRightDrawer: 'closeRightDrawerBotWorkflow',
      },
    };
  },
  created() {
    EventBus.$on('openRightDrawerBotWorkflow', () => {
      this.axios.get(`${this.url}?fields=text`).then((response) => {
        this.form.text = response.data.text;
      }).catch(() => {});
    });
  },
  destroyed() {
    EventBus.$off('openRightDrawerBotWorkflow');
  },
  watch: {
    text(newVal) {
      this.form.text = newVal;
    },
    'form.text'(newVal, oldVal) { // eslint-disable-line
      if (!oldVal || !newVal) {
        this.text = newVal;
      }
    },
  },
};

</script>

<style scoped>
#fallback-action-buttons {
  position: absolute;
  top: 270px;
  right: 40px;
  width: 100%;
}
#text-error {
  bottom: 0 !important;
  top: 250px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/templateV2/BotFallback.vue